var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "navigation-bar"
  }, [_c('div', {
    staticClass: "div-block-111",
    "class": [_vm.component === 'ApplicationChoice' ? 'active' : '']
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center pointer",
    on: {
      "click": function click($event) {
        return _vm.navigateToStage('ApplicationChoice');
      }
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "bold progressname"
  }, [_vm._v("VÝBER")])])]), _c('div', {
    staticClass: "div-block-111",
    "class": [_vm.component === 'DocumentCompletion' ? 'active' : '']
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center pointer",
    on: {
      "click": function click($event) {
        return _vm.navigateToStage('DocumentCompletion');
      }
    }
  }, [_vm._m(1), _c('div', {
    staticClass: "bold progressname"
  }, [_vm._v("PODKLADY")])])]), _c('div', {
    staticClass: "div-block-111",
    "class": [_vm.component === 'ApplicationSign' ? 'active' : '']
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center pointer",
    on: {
      "click": function click($event) {
        return _vm.navigateToStage('ApplicationSign');
      }
    }
  }, [_vm._m(2), _c('div', {
    staticClass: "bold progressname"
  }, [_vm._v("PODPIS")])])]), _c('div', {
    staticClass: "div-block-111",
    "class": [_vm.component === 'ApplicationApproval' ? 'active' : '']
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center pointer",
    on: {
      "click": function click($event) {
        return _vm.navigateToStage('ApplicationApproval');
      }
    }
  }, [_vm._m(3), _c('div', {
    staticClass: "bold progressname"
  }, [_vm._v("SCHVÁLENIE")])])]), _c('div', {
    staticClass: "div-block-111",
    "class": [_vm.component === 'ApplicationSummary' ? 'active' : '']
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center pointer",
    on: {
      "click": function click($event) {
        return _vm.navigateToStage('ApplicationSummary');
      }
    }
  }, [_vm._m(4), _c('div', {
    staticClass: "bold progressname"
  }, [_vm._v("ČERPANIE")])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-110"
  }, [_c('div', [_vm._v("1")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-110"
  }, [_c('div', [_vm._v("2")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-110"
  }, [_c('div', [_vm._v("3")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-110"
  }, [_c('div', [_vm._v("4")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-110"
  }, [_c('div', [_vm._v("5")])]);

}]

export { render, staticRenderFns }